import * as React from 'react';

interface INewsletterProps {
  title: string;
  className?: string;
}

const Newsletter = ({ title, className }: INewsletterProps) => {
  if ('string' !== typeof process.env.REACT_APP_SUBSCRIBE_TO_NEWSLETTER_URL) {
    return null;
  }
  return (
    <div className={`newsletter ${className ? className : ''}`}>
      <p className="newsletter__title">{title}</p>

      <a href={process.env.REACT_APP_SUBSCRIBE_TO_NEWSLETTER_URL} target="_blank" rel="noreferrer">
        <div className="newsletter__form">
          <input
            type="email"
            autoCapitalize="off"
            autoCorrect="off"
            name="MERGE0"
            id="MERGE0"
            placeholder="Your E-mail"
          />
          <button className="btn">Subscribe</button>
        </div>
      </a>
    </div>
  );
};

export default Newsletter;



// WEBPACK FOOTER //
// ./src/components/Newsletter/Newsletter.tsx